import { JsonFormsStateProps } from "components/CRPComponents/JsonForm/JsonFormsComponent/types";
import { useCallback } from "react";
import { SchemaData } from "./types";
import { CreateGql, CREATE_QUERY } from "../queries/create";
import { ApiCMSRequest } from "data/ApiCMS";
import { useNavigate } from "react-router-dom";

export default function useCreate() {
  const navigate = useNavigate();

  const handleSave = useCallback(async (state: JsonFormsStateProps<SchemaData>) => {
    const { updatedAt, createdAt, ...data } = state?.data;

    const response = await ApiCMSRequest<CreateGql>({
      query: CREATE_QUERY,
      variables: {
        data,
      },
    });

    if (response?.data?.errors) {
      throw response.data.errors[0];
    }
    if (!response?.data?.data || !response?.data?.data?.createBlogCategory?.id) {
      throw new Error("Ops. Sem resposta!");
    }

    navigate(`/uniftec/blog-categorias/${response.data.data.createBlogCategory.id}`);

    return response;
  }, []);

  return {
    handleSave,
  };
}
